import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import React from 'react';
import Form from 'react-formal';
import { injectIntl } from 'react-intl';

const styles = require('./FormMessage-styles.module.scss');

function FormMessage({ className, intl, ...props }) {
  return (
    <Form.Message
      {...props}
      className={classNames(className, styles.message)}
      extract={error => {
        const msg = error.message || error;
        if (typeof msg === 'string') return msg;
        return intl.formatMessage(msg, msg.values || error.values);
      }}
    >
      {(messages, inner) => <span {...inner}>{messages[0]}</span>}
    </Form.Message>
  );
}

const IntlFormMessage = injectIntl(FormMessage);

export default IntlFormMessage;
